export enum PreviewSessionStatus {
  ACTIVE = 'ACTIVE',
  TERMINATING = 'TERMINATING',
}

/** Persisted session entry stored in localStorage */
export interface PersistedPreviewSession {
  deviceId: string;
  /** Device Serial Number — for display only; deviceId remains the logical identifier */
  dsn?: string;
  customerId: string;
  creativeId: string;
  /** Expiration timestamp in milliseconds (Date.now() compatible) */
  expiresAt: number;
  marketplace: string;
  deviceFamily: string;
  placement: string;
}

/** Session entry exposed to UI - includes ephemeral status */
export interface PreviewSessionEntry extends PersistedPreviewSession {
  status: PreviewSessionStatus;
}

/** Input for creating a new session (context fields injected by hook) */
export type PreviewSessionInput = Omit<
  PersistedPreviewSession,
  'marketplace' | 'deviceFamily' | 'placement'
>;
